module.exports = __webpack_public_path__ + "static/media/Scan 17.5c089e7b.jpeg";